// extracted by mini-css-extract-plugin
export default {"noti":"Notification_noti__44Aq2","noti__top-box":"Notification_noti__top-box__Grb-V","noti__tit":"Notification_noti__tit__GvCzU","noti__box":"Notification_noti__box__n-KZK"};